import { useMemo } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import LinkUtil from "../../utils/LinkUtil";
import { otherInfoContactNumber } from "./constants";
import "./style.css";
import TermsAndCondition from "./TermsAndCondition";
import useDiwaliHook from "./useDiwaliHook";

const DiwaliContainer = () => {
  const { homepageData, carouselData, trackEvent, lang } = useDiwaliHook();

  const handleTracking = (event: any, attributes: any, newSourcePage?:any) => {
    trackEvent(event, attributes, newSourcePage)
  }

  const phone = useMemo(() => <span onClick={() => LinkUtil.phone(otherInfoContactNumber)}>{otherInfoContactNumber}</span>, []);
  const otherInfoCallHi = useMemo(() => <>अधिक जानकारी के लिए हमें {phone} पर कॉल करें।</>, [phone]);
  const otherInfoCall = useMemo(() => <>For more information, call us on {phone}.</>, [phone]);
  
  return (
    <div className="main_container">
      <h1 className="diwali_dhamaka_container">
        <img src={homepageData?.diwaliDhamakaImg} alt="diwali-dhamaka" className="diwali_dhamaka" />
      </h1>
      <Carousel 
        infiniteLoop 
        showThumbs={false} 
        swipeable 
        autoPlay 
        interval={3000} 
        showArrows={false} 
        centerMode 
        centerSlidePercentage={60} 
        selectedItem={6} 
        showStatus={false} 
        showIndicators={false}
      >
        <div> <img src={carouselData?.carouselImgOne} alt="carasoul_img_1" /> </div>
        <div> <img src={carouselData?.carouselImgTwo} alt="carasoul_img_2" /> </div>
        <div> <img src={carouselData?.carouselImgThree} alt="carasoul_img_3" /> </div>
        <div> <img src={carouselData?.carouselImgFour} alt="carasoul_img_4" /> </div>
        <div> <img src={carouselData?.carouselImgFive} alt="carasoul_img_5" /> </div>
        <div> <img src={carouselData?.carouselImgSix} alt="carasoul_img_6" /> </div>
        <div> <img src={carouselData?.carouselImgSeven} alt="carasoul_img_6" /> </div>
        <div> <img src={carouselData?.carouselImgEight} alt="carasoul_img_6" /> </div>
      </Carousel>

      <div className="winners_heading">
        <img src={homepageData?.winnersHeading} alt="winners" />
      </div>

      <div className="winner_container">
        <div className="flex_space_between">
          <div className="flex_space_between">
            <h3 className="section_heading"> {homepageData?.homepageWinnerHeadingOne} </h3>
            <img src={homepageData?.diwaliBlast} alt="diwali-blast" className="diwali_blast" />
          </div>
          <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/1/" }} className="see_all_btn" onClick={() => handleTracking('cta_aaj_ka_superstar', {event_type: 'click'})}>
            <p>See all</p>
          </Link>
        </div>
        <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/1" }} onClick={() => handleTracking('cta_aaj_ka_superstar', {event_type: 'click'})}>
          <img className="daily_winner_banner" src={homepageData?.dailyWinner} alt="daily_winner" />
        </Link>
      </div>

      <div className="winner_container">
        <div className="flex_space_between">
          <div className="flex_space_between">
            <h3 className="section_heading"> {homepageData?.homepageWinnerHeadingTwo} </h3>
            <img src={homepageData?.diwaliBlast} alt="diwali-blast" className="diwali_blast" />
          </div>
          <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/2" }} className="see_all_btn" onClick={() => handleTracking('cta_aaj_ka_khiladi', {event_type: 'click'})}>
            <p>See all</p>
          </Link>
        </div>
        <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/2" }} onClick={() => handleTracking('cta_aaj_ka_khiladi', {event_type: 'click'})}>
          <img className="daily_winner_banner" src={homepageData?.dailyWinnerInactive} alt="daily_winner" />
        </Link>
      </div>

      <div className="winner_container">
        <div className="flex_space_between">
          <div className="flex_space_between">
            <h3 className="section_heading"> {homepageData?.homepageWinnerHeadingThree} </h3>
            <img src={homepageData?.diwaliBlast} alt="diwali-blast" className="diwali_blast" />
          </div>
          <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/3" }} className="see_all_btn" onClick={() => handleTracking('cta_bijak_baazigar', {event_type: 'click'})}>
            <p>See all</p>
          </Link>
        </div>
        <Link to={{ pathname: "/bijak-diwali-dhamaka-2023/winners/3" }} onClick={() => handleTracking('cta_bijak_baazigar', {event_type: 'click'})}>
          <img className="weekly_winner_banner" src={homepageData?.weeklyWinner} alt="weekly_winner" />
        </Link>
      </div>

      <div className="rewards_category_container">
        <h3 className="section_heading"> {homepageData?.homepageAwardCategoryHeading} </h3>
        <div className="rewards_categories">
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/1' onClick={() => handleTracking('cta_bahubali_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryOne} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/2' onClick={() => handleTracking('cta_zabardast_trader_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryTwo} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/3' onClick={() => handleTracking('cta_saathi_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryThree} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/4' onClick={() => handleTracking('cta_no_one_yaari_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryFour} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/5' onClick={() => handleTracking('cta_baazigar_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryFive} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2023/leaderboard/6' onClick={() => handleTracking('cta_area_ka_star_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategorySix} alt="reward-category" />
          </Link>
          {/* <Link to='/bijak-diwali-dhamaka-2022/leaderboard/7' onClick={() => handleTracking('cta_aaj_ka_superstar_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategorySeven} alt="reward-category" />
          </Link>
          <Link to='/bijak-diwali-dhamaka-2022/leaderboard/8' onClick={() => handleTracking('cta_aaj_ka_khiladi_award', {event_type: 'click'})} className="reward_category">
            <img src={homepageData?.rewardCategoryEight} alt="reward-category" />
          </Link> */}
        </div>
      </div>

      <TermsAndCondition src={homepageData?.termsAndConditions} />
      <div className="diwali-more-info-contact">
        <p>{lang === 'hi' ? otherInfoCallHi : otherInfoCall}</p>
      </div>
    </div>
  );
};

export default DiwaliContainer;
